// extracted by mini-css-extract-plugin
export var container = "_bn-0";
export var icon = "_bn-1";
export var text = "_bn-2";